// extracted by mini-css-extract-plugin
module.exports = {"linkDefaults":"Link-module--linkDefaults--3hH0D"};